export const CONTRACT_STATUS = {
  ACTIVE: 'Active',
  TERMINATING: 'Terminating',
  TERMINATED: 'Terminated'
}

export const CONSOLIDATED = {
  ALL: 'all',
  NONE: 'none',
  PARTIAL: 'partial'
}

export const NAV_LOCK_LEVEL = {
  NONE: 'none',
  PARTIAL: 'partial',
  FULL: 'full'
}

export const LEARN_MORE_TYPE = {
  TERMINATION: 'termination',
  REJOIN: 'rejoin'
}

export const LOCKED_ROUTES_PARTIAL = [
  'home',
  'promos',
  'BundleDashboard',
  'foundry_profile',
  'user_permissions',
]
